<div [class]="customClasses().formGroup">
    <label [class]="customClasses().label">{{ label() }}</label>
    <div class="form-check form-switch">
        <input
            class="form-check-input"
            [class]="customClasses()?.input"
            [class.is-invalid]="ngControl.touched && ngControl.invalid"
            type="{{ type }}"
            role="switch"
            [formControl]="ngControl.control | formControl"
            [checked]="checked()"
            [attr.data-qa]="testAutomationSelectorName()"
            (change)="handleCheckboxChange($event)"
        />
    </div>

    @if (ngControl.control?.errors?.['required']) {
        <div class="invalid-feedback d-block">Please enable the {{ label() | lowercase }}</div>
    }
</div>
